import ToolTipIcon from "./toolTipIcon";
export * from "./fairGoTooltip";

export default ToolTipIcon;
